export default __webpack_public_path__ + "static/debbie-f5d6abbbb0b01f081420236d1d60a886.jpg";